import { Component, Input, OnInit } from '@angular/core';
import { AbstractControl, FormGroup, FormGroupName } from '@angular/forms';
import { ValidateFieldsService } from '../../services/validate-fields.service';

@Component({
  selector: 'app-input-select',
  templateUrl: './input-select.component.html',
  styleUrls: ['./input-select.component.scss'],
})
export class InputSelectComponent implements OnInit {
  @Input() id: string;
  @Input() title: string;
  @Input() name: string;
  @Input() formGroup: FormGroup;
  @Input() controlName: string;
  @Input() values: any[];
  @Input() valuesNum: string[];
  @Input() readonly: boolean;
  @Input() errorMessage: string;
  @Input() classInfo: string;

  constructor(public validate: ValidateFieldsService) { }

  ngOnInit(): void { }

  get formControl(): AbstractControl {
    return this.formGroup.controls[this.controlName];
  }
}
